import DistanciersController from './distanciers.controller';

export default {
    template: require('./distanciers.tpl.html'),
    controller: DistanciersController
};
